<template>
  <v-container fluid class="pa-0 mt-5 fill-width">

    <!-- Agreement chọn -->
    <v-card class="mb-3 pa-0">
      <v-select
        label="Agreement"
        v-model="consentInfo"
        :items="consentList"
        item-text="consentTitle"
        item-value="consentId"
        return-object
        dense
        outlined
        @change="doItemChange"
      />
    </v-card>
    <!-- Form -->
    <v-card class="pa-0">

      <h2 class="text-center mb-3">
        {{ consentInfo.consentTitle || '' }}
      </h2>

      <!-- Employee -->
      <v-text-field
        v-model="empCode"
        label="Mã số"
        :disabled="disabled"
        @change="doItemChange"
        clearable
      />

      <v-text-field
        v-model="agreeInfo.empNm"
        label="Tên"
        readonly
      />

      <!-- Terms -->
      <!-- <div class="agreement-content" style="white-space: pre-line;">
         {{ consentInfo.consentVn || '' }}
      </div> -->

      <div class="html-content" v-html="consentInfo.htmlContent"></div>

      <h3>XÁC NHẬN ĐỒNG Ý</h3>
      <div v-if="dynamicKeys.length">
        <div v-for="key in dynamicKeys" :key="key">
          <v-checkbox
            v-model="agreement[key]"
            :label="consentInfo[key]"
          />
        </div>
      </div>

      <!-- Canvas -->
      <canvas ref="canvas" class="signature"></canvas>
      
      <v-btn small @click="clear">Xóa chữ ký</v-btn>
      
    <!-- Actions -->
      <div id="loader"></div>

      <div class="text-center mt-3">
        <v-btn color="success"  block  size="50%" @click="submit()"  :disabled="isSubmitted"> {{ submitbtn_nm }} </v-btn>
        <v-btn color="success"  block  size="50%" @click="previewPDF()" :disabled="!isSubmitted"> Tải thỏa thuận </v-btn>
      </div>

      <HDPdfViewer
        v-if="showPreview"
        :src="pdfUrl"
        @close="showPreview = false"
        @download="downloadFile"
      />
    </v-card>

    <VueToastify :notifyAction="notifyAction"/>

  </v-container> 
</template>

<script>

import SignaturePad from "signature_pad"
import { getConsentInfo, getEmpInfo, getAgreement, submitAgreement, downloadAgreement } from "@/api/view/mis/10/v10a7000.js"
import VueToastify from "@/components/toastify/VueToastify.vue"
import HDPdfViewer from "@/layout/components/HDPdfViewer.vue"

export default {
  components: { VueToastify, HDPdfViewer},
  data() {
    return {

      showPreview: false,
      pdfUrl: null,
      empCode: "" ,
      submitbtn_nm: "Gửi",
      consentList: [],
      consentInfo: {},
      agreeInfo: {},
      empInfo: {},
      signaturePad: null,
      signatureImage: null,
      agree: false,
      disabled: false,
      isSubmitted: false,
      agreement: {},
      dynamicKeys: [],  
      language: ""    
    }
  },

  watch: {
    'empCode'(newVal, oldVal) {
      if (!newVal || newVal === oldVal) return
      this.getAgreementInf()
    }
  },

  async mounted() {
    await this.getConsentInf();

    this.empCode = this.$store.state.user.userId;

    await this.getEmpInf(this.empCode);

    // const vnCodes = ["2", "5", "6", "7"]
    // this.language = vnCodes.includes(this.empCode.substring(0, 1)) ? "VN" : "EN" ;

    this.language = "VI" ;

    this.doItemChange();

    this.$nextTick(() => {
      this.initCanvas();
    });
  },

  methods: {
    
    notifyAction(notifyInfo, action) {
      this.$EventBus.$emit(`${this.$route.meta.menu_id}_notifyAction`, { notifyInfo: notifyInfo, action: action })
    },
    /* ================= INIT ================= */
    initCanvas() {
        const canvas = this.$refs.canvas
        const ratio = Math.max(window.devicePixelRatio || 1, 1)

        canvas.width = canvas.offsetWidth * ratio
        canvas.height = 200 * ratio

        canvas.getContext("2d").scale(ratio, ratio)

        if (this.signaturePad) {
          this.signaturePad.clear()
        }

        this.signaturePad = new SignaturePad(canvas)
    },

    /* ================= AUTHORITY ================= */
    async author(emNo) {
            let params = {
                menuId: 'v10a7000',
                empNo: emNo,
                tabNo: '99',
                div: '1'
            }
            await getAuthor(params).then(res => {
                res.list.forEach(e => {
                    this.useYn = e.useYn
                });
            })

            await getGroup(params).then(res => {
                res.list.forEach(e => {
                    this.grpCd = e.grpCd
                });
            })
            
            if (this.useYn != 'Y' || this.useYn== null) {
                this.disabled = true
            }
        },

    /* ================= DATA ================= */

    async getConsentInf(){

      let parm = {
          consentId : "",
          lang: this.language
      }

      try {
        await getConsentInfo(parm).then(res => {

              this.consentList = res.list 

              if (this.consentList.length > 0) {
                this.consentInfo = this.consentList[0]

                //console.log(this.consentInfo)
              }

          })
      } catch (e) {
        console.error(e)
      }
    },

    async getEmpInf(emNo) {
      let parm = {
          empNo : emNo
      }
      await getEmpInfo(parm).then(res => {

              this.empInfo = res.list[0]
              //console.log(this.empInfo)
      }) ;
    },

    async getAgreementInf() {
      //if (!this.consentInfo.consentId || !this.agreeInfo.empNo) return

      const res = await getAgreement({
        consentId: this.consentInfo.consentId,
        empNo: this.empCode
      })

      this.agreeInfo = res.list?.[0] || {}

      if (this.agreeInfo?.signaturePic) {
        this.signatureImage = this.toBase64(this.agreeInfo.signaturePic)
        this.applySignature()
      }

      // this.agreeInfo.htmlContent = this.agreeInfo.htmlContent
      //   ?.replace(/{{picEmpnm}}/g, this.consentInfo.picEmpnm || "")
      //   ?.replace(/{{picEmail}}/g, this.consentInfo.picEmail || "")
      //   ?.replace(/{{webPage}}/g, this.consentInfo.webPage || "");

      this.agreement = Object.fromEntries(
        this.dynamicKeys.map(key => {
          const ynKey = key + "Yn";
          return [key, this.agreeInfo?.[ynKey] === "Y"];
        })
      );


      //console.log(this.agreement) 

      this.agree = Object.values(this.agreement).every(v => v === true);
      this.isSubmitted = this.agree 
      this.submitbtn_nm = this.isSubmitted ? "Đã gửi" : "Gửi";

      //this.getEmpInf(emNo) ;
    },

    doItemChange() {
        if (!this.consentInfo) return;

        this.dynamicKeys = Object.keys(this.consentInfo)
          .filter(key => key.startsWith("cond") && this.consentInfo[key]);

        this.getAgreementInf()
      },

    /* ================= SIGNATURE ================= */

    applySignature() {
      //const img = new Image()
      //img.src = this.signatureImage

      //img.onload = () => {
      //  const canvas = this.$refs.canvas
       // const ctx = canvas.getContext("2d")

        this.signaturePad.clear()

        this.signaturePad.fromDataURL(this.signatureImage)

        // // const ratio = Math.min(
        // //   canvas.width /img.width,
        // //   canvas.height / img.height
        // // )

        // //console.log(ratio) 
        // const ratio = Math.min(0.5, 0.5)

        // //console.log(ratio) 

        // ctx.drawImage(
        //   img,
        //   0,
        //   0,
        //   img.width * ratio,
        //   img.height * ratio
        // )
        this.signaturePad._data = [{}] 
      //}
    },

    onImageUpload(file) {
      if (!file) return

      const reader = new FileReader()
      reader.onload = e => {
        this.signatureImage = e.target.result
      }
      reader.readAsDataURL(file)
    },

    clear() {
      this.signaturePad.clear()
    },

    setAgreeInfo() {

      this.agreeInfo.consentId = this.consentInfo.consentId ;
      this.agreeInfo.consentTitle = this.consentInfo.consentTitle ;
      this.agreeInfo.consentVn = this.consentInfo.consentVn ;
      this.agreeInfo.consentEn = this.consentInfo.consentEn ;
      this.agreeInfo.consentKr = this.consentInfo.consentKr ;
      this.agreeInfo.userId = this.$store.state.user.userId ;
      this.agreeInfo.ipAddr = "192.168.1.1" ;
      this.agreeInfo.userAgent = "Mobile" ;
      this.agreeInfo.picEmpno = this.consentInfo.picEmpno ;
      this.agreeInfo.picEmpnm = this.consentInfo.picEmpnm ;
      this.agreeInfo.webPage = this.consentInfo.webPage ;
      this.agreeInfo.picPos = this.consentInfo.picPos ;
      this.agreeInfo.picEmail = this.consentInfo.picEmail ;
      this.agreeInfo.consentpdfUrl = this.consentInfo.consentpdfUrl ;
      this.agreeInfo.appFr = this.consentInfo.appFr ;
      this.agreeInfo.lang = this.language ;
      
      this.agreeInfo.brthDt = this.empInfo.brthDt ;
      this.agreeInfo.deptNm = this.empInfo.deptNm ;
      this.agreeInfo.sectNm = this.empInfo.sectNm ;
      this.agreeInfo.grpNm  = this.empInfo.grpNm ;
      this.agreeInfo.tel    = this.empInfo.tel ;
     
      this.dynamicKeys.forEach(key => {
        const ynKey = key + "Yn";
        this.agreeInfo[ynKey] = this.agreement?.[key] ? "Y" : "N";
      });

      
    },

    /* ================= ACTION ================= */

    async submit() {


      if (this.isSubmitted) return;

      this.agree = Object.values(this.agreement).every(v => v === true);

      if (!this.agree) {
        alert("Bạn phải đồng ý tất cả các mục trên kiện trên")
        return
      }

      if (this.signaturePad.isEmpty()) {
        alert("Chưa ký")
        return
      }

      loading(true);

      this.setAgreeInfo() 
      const payload = {
        ...this.agreeInfo,
        signaturePic: this.signaturePad.toDataURL()
      }

      //console.log(payload)
      try {

        const res = await submitAgreement(payload)

        //console.log("Return :" + res) 

        if (res.body === "Y") {
          //alert("Gửi thành công")
          this.notifyAction(this.$t('Đã gửi thành công '), 'Thông báo') 
          this.submitbtn_nm = "Đã gửi"
          this.isSubmitted = true ;
          
        } else {
          //this.$toast.error("Xảy ra lỗi trong quá trình gửi")
          this.notifyAction(this.$t('Xảy ra lỗi trong quá trình gửi'), 'Lỗi') 
          this.submitbtn_nm = "Gửi"
          this.isSubmitted = false ;

        }

      }catch (e) {

        console.error(e)
      } finally {
        loading(false);
      }
      
    },

    async previewPDF2() {
      const params = {
        pdfUrl: this.consentInfo.consentpdfUrl,
        consentId: this.consentInfo.consentId,
        empNo: this.empCode
      }

      loading(true)

      try {


        const res = await downloadAgreement(params)

        //const blob = new Blob([res], { type: "application/pdf" })

        this.pdfUrl = URL.createObjectURL(blob)

        this.showPreview = true
      }catch (e){
        console.error(e)
        alert("Download lỗi")

      }finally {
        loading(false)
      }
    },

    async previewPDF() {
      if (!this.isSubmitted) {
        alert("Chưa gửi thỏa thuận")
        return
      }

      const params = {
        pdfUrl: this.consentInfo.consentpdfUrl,
        consentId: this.consentInfo.consentId,
        empNo: this.empCode
      }

      loading(true)
      try {

        const res = await downloadAgreement(params)

        // console.log(res)
        // console.log(typeof res.data)
        // console.log(res.data)

        //console.log(res.data) // 👉 phải là Blob hoặc ArrayBuffer

        //const blob = new Blob([res], { type: 'application/pdf' })

        //console.log(blob)

        this.pdfUrl = window.URL.createObjectURL(res)

        this.showPreview = true

      } catch (e) {
        console.error(e)
        alert("Download lỗi")
      }
      finally {
        loading(false)

      }
    },

    downloadFile() {

        const link = document.createElement('a')
        link.href = this.pdfUrl
        link.download = `Consent_${this.consentInfo.consentId}_${this.empCode}.pdf`
        link.click()
    },

    closePreview() {
      this.showPreview = false

      // cleanup memory (rất quan trọng)
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl)
        this.pdfUrl = null
      }
    },

    toBase64(str) {
      if (!str) return null
      return str.startsWith("data:image")
        ? str
        : "data:image/png;base64," + str
    }

  }
} ;

function loading(show){
  if(show)
      document.getElementById("loader").style.display = "block";
  else
      document.getElementById("loader").style.display = "none";
} ;

</script>

<style scoped>
.signature {
  border: 1px solid #ccc;
  width: 100%;
  height: 200px;
}

.preview-img {
  max-height: 80px;
  margin-bottom: 10px;
}

.agreement-content {
  font-family: "Times New Roman", serif;
  font-size: 14px;
  line-height: 1.4;
  color: #000;
  text-align: justify;
}

.agreement-content h1,
.agreement-content h2 {
  text-align: center;
  font-weight: bold;
}

.agreement-content p {
  margin-bottom: 6px;
}

.agreement-content strong {
  font-weight: bold;
}

.html-content {
  font-size: 13px;
  line-height: 1.5;
  padding: 8px !important;
  margin-top: 10px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

.html-content h1 {
  font-size: 16px;
  text-align: center;
}

.html-content h2 {
  font-size: 14px;
  margin-top: 6px;
}

.html-content p,
.html-content li {
  font-size: 13px;
}
/* 🔥 FIX ul */
.html-content ul {
  padding-left: 16px !important;
}

/* 🔥 FIX table */
.html-content table {
  width: 100% !important;
  margin: 0 !important;
}

/* 🔥 FIX div có padding */
.html-content div {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.fill-width {
  max-width: 100% !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.v-container {
  max-width: 100% !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.v-card {
  max-width: 1000px;
  width: 100% ;
  margin: auto;
}

.signature {
  border: 1px solid #ccc;
  width: 100%;
  height: 150px;
  margin-top: 10px;
}

.pdf-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdf-container {
  width: 80%;
  height: 80%;
  background: white;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 10;
}

.pdf-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 9999;
}

.pdf-modal {
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 90%;
  background: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
}

/* HEADER */
.pdf-header {
  padding: 10px;
  background: #2c3e50;
  color: white;
  display: flex;
  justify-content: space-between;
}

/* BODY */
.pdf-body {
  flex: 1;
}

.pdf-body iframe {
  width: 100%;
  height: 100%;
}

/* FOOTER */
.pdf-footer {
  padding: 10px;
  text-align: right;
  border-top: 1px solid #ddd;
}

.pdf-footer button {
  margin-left: 10px;
  padding: 6px 12px;
}

@media (max-width: 600px) {
  .v-card {
    margin: 0 !important;
    margin-top: 10px !important;
    border-radius: 0 !important;
  }
}

#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 120px;
  height: 120px;
  margin: -76px 0 0 -76px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  display: none;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Add animation to "page content" */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s
}

@-webkit-keyframes animatebottom {
  from { bottom:-100px; opacity:0 } 
  to { bottom:0px; opacity:1 }
}

@keyframes animatebottom { 
  from{ bottom:-100px; opacity:0 } 
  to{ bottom:0; opacity:1 }
}
</style>